export default "__VITE_ASSET__a3905a6e__"